import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Ticket, Search, TicketCheck, LifeBuoy } from "lucide-react";

interface MobileFooterProps {
  currentPage: string;
  onNavigate: (page: string) => void;
  onSearch: (trigger: HTMLButtonElement) => void;
}

export function MobileFooter({ currentPage, onNavigate, onSearch }: MobileFooterProps) {
  const reduced = useReducedMotion();
  const menuItems = [
    { icon: Ticket, iconName: "ticket", label: "Eventos", page: "home" },
    { icon: Search, iconName: "search", label: "Buscar", page: "search" },
    { icon: TicketCheck, iconName: "ticket-check", label: "Ingressos", page: "my-tickets" },
    { icon: LifeBuoy, iconName: "life-buoy", label: "Ajuda", page: "ajuda" },
  ];

  return <nav className="mobile-footer-container" aria-label="Navegação no celular">
    <div className="mobile-footer-content">
      <div className="mobile-footer-nav">
        {menuItems.map((item) => {
          const isActive = currentPage === item.page;
          return <button key={item.page} data-icon={item.iconName}
            className={`mobile-footer-item ${isActive ? "mobile-footer-item-active" : ""}`}
            aria-current={isActive ? 'page' : undefined}
            aria-label={item.page === 'my-tickets' ? 'Meus ingressos' : item.label}
            aria-haspopup={item.page === 'search' ? 'dialog' : undefined}
            onClick={(event) => item.page === 'search' ? onSearch(event.currentTarget) : onNavigate(item.page)}>
            {isActive && <motion.span className="mobile-footer-selection" layoutId="mobile-navigation-selection" transition={{ duration: reduced ? 0 : .3, ease: [.22, 1, .36, 1] }} aria-hidden="true" />}
            <div className="mobile-footer-icon-container"><item.icon size={21} className="unique-mobile-nav__icon" aria-hidden="true" /></div>
            <span className="unique-mobile-nav__label">{item.label}</span>
          </button>;
        })}
      </div>
    </div>
  </nav>;
}
